<ng-content select="kb-accordion-panel"></ng-content>
